import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { PrestacaoConta } from "app/entity/prestacao-conta.model";
import { bObservableUsuario } from "app/util/observable-util";
import { catchError, map } from "rxjs/operators";
import { Observable } from "rxjs/Rx";
import { ProgramaRelatorioCnaiCnpc } from "app/entity/relatorio-programas-cnai-cnpc";
import { FuncaoRelatorioCnaiCnpc } from "app/entity/relatorio-funcoes-cnai-cnpc";
import { environment } from "../../environments/environment";
import {
  cacheable,
  clearCache,
  headers,
  headersBlob,
} from "../util/rxjs-functions";
import { RecursoFiltro } from "app/entity/recurso-filtro.model";
import { PrazoPrestacaoConta } from "app/entity/prazo-prestacao-conta.model";
import {RelatorioService} from './relatorio.service';
import { GerenciamentoCurso } from "app/entity/gerenciamento-curso.model";

@Injectable()
export class PadraoService {

  dadosReplicadoCurso: GerenciamentoCurso;
  exibirAvisoReplica: boolean = false;

  constructor(public http: Http, private bObservable: bObservableUsuario,
              private readonly serviceRelatorio: RelatorioService) {}

  LimparCache = (key: string) => clearCache(key);

  ObterAnexo = (
    route: string,
    id: number,
    key: string,
    classtype: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/${classtype}/${id}/${key}`,
            headers()
          )
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  ObterAnexoById = (
    route: string,
    id: number,
    key: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/${id}/${key}`,
            headersBlob()
          )
          .pipe(
            map((res) => res),
            catchError(this.parseErrorBlob)
          ),
      cacheKey,
      refresh
    );
  ObterDocumento = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers(filtro))
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  Adicionar(route: string, obj: any): Observable<any> {
    return this.http
      .post(`${environment.apiEndpoint}/${route}`, obj, headers())
      .map((res) => <any>res.json());
  }
  Atualizar(route: string, obj: any, parcial?: any): Observable<any> {
    return this.http
      .put(`${environment.apiEndpoint}/${route}`, obj, headers(parcial))
      .map((res) => <any>res.json());
  }
  AtualizarPrestacaoConta(
    route: string,
    Obj: any[],
    dto: PrestacaoConta,
    parcial?: any
  ): Observable<any> {
    return this.http.post(
      `${environment.apiEndpoint}/${route}` + "/AtualizarPrestacaoConta",
      Obj,
      headers(parcial)
    );
  }
  EnviarPrestacaoConta(
    route: string,
    dto: any,
    parcial?: any
  ): Observable<any> {
    return this.http.post(
      `${environment.apiEndpoint}/${route}` + "/EnviarPrestacaoConta",
      dto,
      headers(parcial)
    );
  }
  AtualizarAtividadeHomologacao(
    route: string,
    AtividadeHomologacao: any,
    parcial?: any
  ) {
    return this.http.post(
      `${environment.apiEndpoint}/${route}` + "/atualizarAtividadeHomologacao",
      AtividadeHomologacao,
      headers(parcial)
    );
  }
  Deletar(route: string, id: number): Observable<any> {
    return this.http
      .delete(`${environment.apiEndpoint}/${route}/${id}`, headers())
      .map((res) => <any>res.json());
  }
  Obter = (
    route: string,
    id: number,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}/${id}`, headers())
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  ExcluirAtividadeProcessoFisico = (
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/prestacaoConta/excluirAtividadeProcessoFisico`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  EnviarAtividadeCadastrada = (
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/prestacaoConta/EnviarAtividadeCadastrada`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  VerificaPrestacaoConta = (
    cpf: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/prestacaoConta/verificaPrestacaoConta/${cpf}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ObterPermissaoGerarCertificado = (
    route: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers())
          .map((res: Response) => <boolean>res.json()),
      cacheKey,
      refresh
    );
  ListarTodosUsuarios = (
    route: string,
    filtro?: any,
    filtro2?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/obterUsuarios/${filtro}/${filtro2}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarPontuacaoHomologacao = (
    route: string,
    id?: any,
    perfil?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listaPontuacao/${id}/${perfil}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarHomologacaoConteudoEvento = (
    route: string,
    id?: any,
    perfil?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listaPontuacaoEvento/${id}/${perfil}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );

  ObterDadosRegistroLogado = (
    cpf: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/usuario/obterDadosRegistroLogado/${cpf}`,
            headers()
          )
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  ObterCodigo = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}/codigo`, headers(filtro))
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarPorCurso = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/ListarPorCurso`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarPorAtividade = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/ListarPorAtividade/`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );

    ListarPorAtividadeAvulsas = (
      route: string,
      filtro?: any,
      cacheKey?: string,
      refresh: boolean = false
    ) =>
      cacheable(
        () =>
          this.http
            .get(
              `${environment.apiEndpoint}/${route}/ListarPorAtividadeAvulsas/`,
              headers(filtro)
            )
            .map((res: Response) => <any[]>res.json()),
        cacheKey,
        refresh
      );


  ListarInstrutores = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listarTodosFiltrado`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
    

    ListarRelatores = (
      route: string,
      filtro?: any,
      cacheKey?: string,
      refresh: boolean = false
    ) =>
      cacheable(
        () =>
          this.http
            .get(
              `${environment.apiEndpoint}/${route}/listaRelatores`,
              headers(filtro)
            )
            .map((res: Response) => <any[]>res.json()),
        cacheKey,
        refresh
      );

  ListarTodos = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http.get(`${environment.apiEndpoint}/${route}/listarTodos`,headers(filtro))
                 .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );

    
    ListarTodosComLimite = (
      route: string,
      filtro?: any,
      cacheKey?: string,
      refresh: boolean = false
    ) =>
      cacheable(
        () =>
          this.http.get(`${environment.apiEndpoint}/${route}/listarTodosComLimite`,headers(filtro))
                   .map((res: Response) => <any[]>res.json()),
        cacheKey,
        refresh
      );
    
  ListarTodosDistinct = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listarTodosDistinct`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarNotificacoes = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listarNotificacoes`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );

  AtualizarById = (
    route: string,
    id: number,
    cacheKey?: string,
    refresh: boolean = true
  ) =>
    cacheable(
      () =>
        this.http
          .put(
            `${environment.apiEndpoint}/${route}/AtualizarById`,
            id,
            headers()
          )
          .map((res) => <any>res.json()),
      cacheKey,
      refresh
    );
  ListarTodosProcessoFisico = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/listarTodosProcessoFisico`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarTodosCapacitadoraCombo = (
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/capacitadora/listarTodasCombo`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarTodosGenerics = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers(filtro))
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarTodosGenericsBoolean = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers(filtro))
          .map((res: Response) => <boolean>res.json()),
      cacheKey,
      refresh
    );
  ObterGenerico = (
    route: string,
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers(filtro))
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  ServicoPrestacaoConta(
    route: string,
    id: number,
    cpf: string,
    obj: any
  ): Observable<any> {
    return this.http
      .post(`${environment.apiEndpoint}/${route}/${id}/${cpf}`, obj, headers())
      .map((res) => <any[]>res.json());
  }
  ObterTodos = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro))
                 .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ObterTodosPorListaDeIds(route: string, list: number[]): Observable<any[]> {
    return this.http
      .post(
        `${environment.apiEndpoint}/${route}/ObterTodosPorListaDeIds`,
        list,
        headers()
      )
      .map((res) => <any[]>res.json());
  }
  Filtro = (
    route: string,
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}`, headers(filtro))
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  AtualizarEnviarCadastro(route: string, id: any): Observable<any> {
    return this.http
      .put(
        `${environment.apiEndpoint}/${route}/atualizaSituacao`,
        id,
        headers()
      )
      .map((res) => <any>res.json());
  }
  UploadExcel(route: string, obj: any): Observable<any> {
    return this.http
      .post(`${environment.apiEndpoint}/${route}/uploadExcel`, obj, headers())
      .map((res) => <any>res.json());
  }
  ObterExcel = (
    filtro: any,
    controller: string,
    action: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .post(
            `${environment.apiEndpoint}/${controller}/${action}/`,
            filtro,
            headersBlob({ "Content-Type": "application/vnd.ms-excel" })
          )
          .map((res: Response) => res),
      cacheKey,
      refresh
    );
  ObterRelatorio = (
    cpf: string,
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/relatorio/relatorioGeral/${cpf}`,
            headersBlob(filtro)
          )
          .map((res: Response) => <any>res),
      cacheKey,
      refresh
    );
  ObterRelatorioAtividadesJulgadas = (
    filtro: any,
    controller: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .post(
            `${environment.apiEndpoint}/relatorio/${controller}/`,
            filtro,
            headersBlob({ "Content-Type": "application/vnd.ms-excel" })
          )
          .map((res: Response) => res),
      cacheKey,
      refresh
    );
    ObterRelatorioAtividadesAtas = (
    filtro: any,
    controller: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .post(
            `${environment.apiEndpoint}/relatorio/${controller}/`,
            filtro,
            headersBlob({ "Content-Type": "application/vnd.ms-excel" })
          )
          .map((res: Response) => res),
      cacheKey,
      refresh
    );

    ObterRelatorioRelatorioProfissionaisCnaiCnpc = (
      filtro: any,
      controller: any,
      cacheKey?: string,
      refresh: boolean = false
    ) =>
      cacheable(
        () =>
          this.http.post(`${environment.apiEndpoint}/relatorio/${controller}/`,
          filtro,
          headersBlob({ "Content-Type": "application/vnd.ms-excel"})).map((res: Response) => res),
        cacheKey,
        refresh
      );

  ObterListaProgramas = (
    cacheKey?: string,
    refresh: boolean = false
  ) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/relatorio/programas`,
      headers())
      .map((res: any) => 
        res.json().map((item: any) => new ProgramaRelatorioCnaiCnpc(item)
      )),
    cacheKey,
    refresh
  );

  ObterListaFuncoes = (
    cacheKey?: string,
    refresh: boolean = false
  ) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/relatorio/funcoes`,
      headers())
      .map((res: any) => res.json()),
    cacheKey,
    refresh
  );

 

    // ObterRelatorioRelatorioProfissionaisCnaiCnpc(
    //     controller: string,
    //     InclusaoPrograma: any,
    //     ExercicioPrestacao: any,  
    //     sigla_regional: any
    //   ): Observable<any> {
    //     var objeto = {
    //       'InclusaoPrograma': InclusaoPrograma,
    //       'ExercicioPrestacao': ExercicioPrestacao,  
    //       'sigla_regional': sigla_regional        }

    //     return this.http
    //       .post(`${environment.apiEndpoint}/relatorio/${controller}/`, objeto, headers())
    //       .map((res) => <any[]>res.json());
    //   }
      

  GetFileById = (
    id: number,
    controller: string,
    action: string,
    filtro: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${controller}/${action}/${id}`,
            headersBlob(filtro)
          )
          .map((res: Response) => res),
      cacheKey,
      refresh
    );
  InteporRecurso(obj: RecursoFiltro, controller: string): Observable<any> {
    return cacheable(
      () =>
        this.http
          .post(
            `${environment.apiEndpoint}/${controller}/interporRecurso`,
            obj,
            headers()
          )
          .map((res) => <any>res.json()),
      null,
      true
    );
  }
  /**
   * Parte de auth abaixo:
   */
  Permissoes = (refresh: boolean = true) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/api/Autenticar/permissao`, headers())
          .map((res) => {
            this.bObservable.setValue({ obj: res.json() });
            return res.json();
          })
          .catch(this.handleAuthError),
      localStorage.getItem("token"),
      refresh
    );
  Login = (refresh: boolean = true) =>
    cacheable(() =>
      this.http
        .get(`${environment.apiEndpoint}/api/Autenticar/login`, headers())
        .map((res) => <any>res.json())
    );
  ObterToken = (code: string, cacheKey?: string, refresh: boolean = false) =>
    cacheable(
      () =>
        this.http
          .post(`${environment.apiEndpoint}/api/Autenticar/Token/${code}`, null)
          .map((res) => <any>res.json()),
      cacheKey,
      refresh
    );
  ObterTokenDecodificado = (refresh: boolean = true) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/api/Autenticar/DecodeToken`,
            headers()
          )
          .map((res) => {
            return res.json();
          }),
      localStorage.getItem("token"),
      refresh
    );
  Logout = () =>
    this.http
      .get(`${environment.apiEndpoint}/api/Autenticar/sair`, headers())
      .subscribe((res) => {
        localStorage.clear();
        window.location.href = `${environment.apiEndpoint}/api/Autenticar/login`;
      });
  private handleAuthError(erro: any): Observable<any> {
    if (erro.status === 403) {
      localStorage.removeItem("token");
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
      return Observable.of(false);
    }
    return Observable.throw(erro);
  }
  ObterLogoLotacao = (
    route: string,
    id: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}/${id}`, headers())
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  ObterCep = (
    route: string,
    id: string,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(`${environment.apiEndpoint}/${route}/${id}`, headers())
          .map((res: Response) => <any>res.json()),
      cacheKey,
      refresh
    );
  GerarCertidao = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}`,
            filtro ? headersBlob(filtro) : headersBlob()
          )
          .pipe(
            map((res) => res),
            catchError(this.parseErrorBlob)
          ),
      cacheKey,
      refresh
    );
  SimularUsuario = (cpf: string, cacheKey?: string, refresh: boolean = false) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/acessos/simularUsuario/${cpf}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  ListarTodasLotacao = (
    route: string,
    filtro?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/${route}/obterLotacao`,
            headers(filtro)
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  FiltroPorte(route: string, obj: any): Observable<any> {
    return this.http
      .post(`${environment.apiEndpoint}/${route}`, obj, headers())
      .map((res) => <any>res.json());
  }
  ListarFuncoesExercidas = (
    cpf?: any,
    id_natureza?: any,
    exercicio?: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http
          .get(
            `${environment.apiEndpoint}/prestacaoConta/getListaFuncoesExercidas/${cpf}/${id_natureza}/${exercicio}`,
            headers()
          )
          .map((res: Response) => <any[]>res.json()),
      cacheKey,
      refresh
    );
  DesfazerTransicaoHomologacao(route: string, obj: any): Observable<any> {
    return this.http
      .put(
        `${
          environment.apiEndpoint
        }/${route}/DesfazerTransicao/${localStorage.getItem("lotacao")}`,
        obj,
        headers()
      )
      .map((res) => <any>res.json());
  }
  parseErrorBlob(err): Observable<any> {
    const reader: FileReader = new FileReader();
    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        try {
          err._body = JSON.parse(reader.result as string);
        } catch (e) {
          err._body = reader.result as string;
        }

        observer.error(err);
        observer.complete();
      };
    });
    reader.readAsText(err._body);
    return obs;
  }
  buscarLotacoes(route: string): Observable<any> {
    return this.http
      .get(`${environment.apiEndpoint}/${route}`, headers())
      .map((res: Response) => <any>res.json());
  }
  buscarAtividadesCamaraPlenaria(
    dataInicio: string,
    dataFim: string,
    idLotacao: number
  ): Observable<any> {
    const rota = `${environment.apiEndpoint}/camaraPlenaria/buscarAtividades?dtIni=${dataInicio}&dtFim=${dataFim}&idLotacao=${idLotacao}`;
    return this.http
      .get(rota, headers())
      .map((res: Response) => <any>res.json());
  }

  Enviar(route: string, id: number): Observable<any> {
    return this.http
      .post(`${environment.apiEndpoint}/${route}`, id, headers())
      .map((res: Response) => <any>res.json());
  }
  temPendencia(year: number): Observable<boolean> {
    return this.http
      .get(
        `${environment.apiEndpoint}/prestarConta/TemPendencia/${year}`,
        headers()
      )
      .map((res: Response) => <boolean>res.json());
  }
  SalvarRascunhoDeJulgamento(route: string, obj: any): Observable<any> {
    return this.http
      .post(
        `${environment.apiEndpoint}/${route}/salvarRascunhoDeJulgamento`,
        obj,
        headers()
      )
      .map((res) => <any>res.json());
  }
  JulgamentoEmLote(route: string, obj: any[]): Observable<any> {
    return this.http
      .put(
        `${environment.apiEndpoint}/${route}/julgamentoEmLote`,
        obj,
        headers()
      )
      .map((res) => <any>res.json());
  }
  v2JulgamentoEmLote(route: string, obj: any[]): Observable<any> {
    return this.http
      .put(
        `${environment.apiEndpoint}/${route}/v2/julgamentoEmLote`,
        obj,
        headers()
      )
      .map((res) => <any>res.json());
  }
  ObterDadosComplementaresJustificativa(route: string, id: number): any {
    return this.http
      .get(
        `${environment.apiEndpoint}/${route}/ObterDadosComplementaresDaJustificativa/${id}`,
        headers()
      )
      .map((res) => <any>res.json());
  }
  ObterHistoricoDaJustificativa(route: string, id: number): any {
    return this.http
      .get(
        `${environment.apiEndpoint}/${route}/obterHistoricoDaJustificativa/${id}`,
        headers()
      )
      .map((res) => <any>res.json());
  }
  EnviarParaJulgamento(route: string, id: number) {
    return this.http.put(
      `${environment.apiEndpoint}/${route}/EnviarParaHomologacao`,
      id,
      headers()
    );
  }
  obterPrazoPrestacao(exercicio: number): any {
    return this.http
      .get(
        `${environment.apiEndpoint}/prazo-prestacao-conta/obterPrazoPrestacao/${exercicio}`,
        headers()
      )
      .map((res) => <any>res.json());
  }

  obterPrazoPrestacaoProfissional(exercicio: number): any {
    return this.http
      .get(
        `${environment.apiEndpoint}/prazo-prestacao-conta/obterPrazoPrestacaoProfissional/${exercicio}`,
        headers()
      )
      .map((res) => <any>res.json());
  }

  // fazerDownloadArquivoProfissionaisCnaiCnpcGerado(chave_arquivo: string) {
  //   throw new Error('Method not implemented.');
  // }

  fazerDownloadArquivoProfissionaisCnaiCnpcGerado = (
    filtro: any,
    controller: any,
    cacheKey?: string,
    refresh: boolean = false
  ) =>
    cacheable(
      () =>
        this.http.post(`${environment.apiEndpoint}/relatorio/${controller}/`
                  ,filtro
                  ,headersBlob({ "Content-Type": "application/vnd.ms-excel"}))
                 .map((res: Response) => res),
      cacheKey,
      refresh
    );

    excluirArquivoProfissionaisCnaiCnpcGerado = (
      filtro: any,
      controller: any,
      cacheKey?: string,
      refresh: boolean = false
    ) =>
      cacheable(
        () =>
          this.http.post(`${environment.apiEndpoint}/relatorio/${controller}/`
                    ,filtro
                    ,headersBlob({ "Content-Type": "application/vnd.ms-excel"}))
                   .map((res: Response) => res),
        cacheKey,
        refresh
      );
  obterRelatorioProfissionaisPorEvento(idEvento: number) {
    return this.serviceRelatorio.obterRelatorioProfissionaisPorEvento(idEvento)
  }

  obterRelatorioProfissionaisPorCurso(idCurso: number) {
    return this.serviceRelatorio.obterRelatorioProfissionaisPorCurso(idCurso)
  }

  obterRelatorioEdicaoDeEvento(idCurso: number) {
    return this.serviceRelatorio.obterRelatorioEdicaoDeEvento(idCurso)
  }


  obterCursoReplicado(): GerenciamentoCurso {
    return this.dadosReplicadoCurso;
  }

  definirCursoReplicado(curso: GerenciamentoCurso) {
    this.dadosReplicadoCurso = curso;
  }

  
  deveExibirAvisoReplica(): boolean {
    return this.exibirAvisoReplica;
  }
  
  definirExibirAvisoReplica(visivel: boolean): boolean {
    if (this.exibirAvisoReplica !== visivel) {
      this.exibirAvisoReplica = visivel;
    }
    
    return this.exibirAvisoReplica;
  }

  limparCursoReplicado(): void {
    this.dadosReplicadoCurso = null;
    this.definirExibirAvisoReplica(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/padrao.service.ts